import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

import { HttpUtilsService } from '../../commons/http-uilis.service';
import { Paging } from '../../../model/paging/paging';
import { environment } from '../../../environment/environment';
import { Amplifier } from '../../../model/amplifier/amplifier';

@Injectable({
  providedIn: 'root'
})
export class AmplifierService_Mock {
  private _url: string = `${environment.baseAPIURL}/settings`;

  constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) {}

  GETPaginatedAmplifiers(paging: Paging) {
    const allData = this.getMockAmplifiers();
    const start = (paging.pageIndex - 1) * paging.pageSize;
    const end = start + paging.pageSize;

    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 12,
      data: {
        count: allData.length,
        items: allData.slice(start, end)
      }
    });
  }

  GETAmplifierById(amplifierId: number) {
    const amplifier = this.getMockAmplifiers().find((item) => item.amplifierId === amplifierId) ?? this.getMockAmplifiers()[0];
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 8,
      data: {
        name: amplifier?.name ?? '',
        gain: amplifier?.gain ?? { freq_24: 0, freq_5: 0, freq_6: 0 },
        note: amplifier?.note ?? '',
        components: amplifier?.components ?? []
      }
    });
  }

  POSTAmplifier(body: Amplifier) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 10,
      data: true
    });
  }

  PUTAmplifier(amplifierId: number, body: Amplifier) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 10,
      data: true
    });
  }

  DELETEAmplifier(amplifierId: number) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 9,
      data: true
    });
  }

  private getMockAmplifiers() {
    return [
      {
        amplifierId: 1,
        name: 'Amp 1',
        gain: { freq_24: 10.5, freq_5: 9.8, freq_6: 8.7 },
        note: 'Main amplifier',
        components: [
          { code: 'C1', value: 100 },
          { code: 'R1', value: 220 }
        ]
      },
      {
        amplifierId: 2,
        name: 'Amp 2',
        gain: { freq_24: 11.0, freq_5: 10.2, freq_6: 9.1 },
        note: 'Backup amplifier',
        components: [{ code: 'C2', value: 150 }]
      },
      {
        amplifierId: 3,
        name: 'Amp 3',
        gain: { freq_24: 9.7, freq_5: 8.9, freq_6: 8.1 },
        note: 'Edge rack',
        components: [
          { code: 'L1', value: 47 },
          { code: 'R5', value: 330 }
        ]
      }
    ];
  }
}
